import { NgModule } from '@angular/core';
import { CookiesConsentComponent } from './consent/consent.component';
import { UIRouterModule } from '@uirouter/angular';
import { CommonModule } from '@angular/common';
import { CookiesConsentService } from './consent/consent.service';
import { CookieModule } from 'ngx-cookie';

@NgModule({
  declarations: [
    CookiesConsentComponent
  ],
  imports: [
    CookieModule,
    UIRouterModule,
    CommonModule
  ],
  providers: [
    CookiesConsentService
  ],
  exports: [
    CookiesConsentComponent
  ]
})
export class CookiesModule {
}



// WEBPACK FOOTER //
// ./src/app/cookies/cookies.module.ts